export default __webpack_public_path__ + "static/media/logo-sm.c6157ce4.png";